const subscriptionsConfig = {
  pk: 'pk_test_51SISQOHBShzMtG9MlpStv53BLM3Z2vi3brjb7jrt8BLDtKsSX7jGwCDbWA1Ff8mZtB04Sg1gqXrYoagQjaQlMaBA00fp9A3lHQ',
};
export default subscriptionsConfig;
